/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
// Imports

import { useCallback, useState } from 'react';
import { StyleSheet } from 'react-native';
import Icon from 'react-native-vector-icons/FontAwesome';
import TextButton from '../elements/TextButton';
import { Text, View } from '../Themed';
import Colors from '../../constants/Colors';

export type MultiChoicePageParamList = {
  prompts: string[];
  options: string[];
  questionCategory: string;
  onSubmit?: (response: string[]) => void;
};

export default function MultiChoicePageAlternative(props: MultiChoicePageParamList) {
  const { prompts, options, questionCategory, onSubmit } = props;
  const [selected, setSelected] = useState<boolean[]>(new Array(props.options.length).fill(false));

  const handleSubmit = useCallback(() => {
    const responses = options.filter((element, idx) => {
      return selected[idx];
    });
    if (typeof onSubmit === 'function') {
      onSubmit(responses);
    }
  }, [options, onSubmit, selected]); // prevents unnecessary renders

  // console.log(`Current options are ${options}`);
  const disabled = selected.filter(Boolean).length === 0;
  return (
    <View style={styles.container}>
      <View style={styles.promptContainer}>
        {prompts.map((prompt, idx) => {
          return (
            <Text style={styles.prompt} key={`MultiChoicePrompt_${idx}`}>
              {prompt}
            </Text>
          );
        })}
      </View>
      <View style={styles.optionContainer}>
        {options.map((option, idx) => {
          return (
            <Icon.Button
              style={{ ...styles.buttonStyle, backgroundColor: selected[idx] ? '#FFFFFFAA' : 'white' }}
              size={30}
              underlayColor="transparent"
              name="check"
              color={selected[idx] ? Colors.snapCalorie.orange : 'transparent'}
              borderRadius={0}
              backgroundColor="transparent"
              iconStyle={{
                borderRadius: 8,
                borderColor: '#31373E',
                borderWidth: 2,
              }}
              onPress={() => {
                const newSelection = [...selected];
                newSelection[idx] = !newSelection[idx];
                setSelected(newSelection);
                // console.log(newSelection);
              }}
              key={`MultiChoiceButton_${idx}`}
            >
              <Text
                style={{
                  fontSize: 20,
                  fontWeight: selected[idx] ? 'bold' : '500',
                  lineHeight: 25,
                  letterSpacing: -0.46,
                  color: '#31373E',
                }}
              >
                {option}
              </Text>
            </Icon.Button>
          );
        })}
      </View>
      <TextButton
        disabled={disabled}
        textStyle={{
          fontSize: 20,
          fontWeight: '600',
          lineHeight: 25,
          letterSpacing: -0.29,
          color: '#F8F5F4',
        }}
        style={[
          styles.buttonWrapper,
          {
            backgroundColor: disabled ? '#31373E' : Colors.snapCalorie.buttonBlue,
          },
        ]}
        onPress={handleSubmit}
        text="Next"
      />
    </View>
  );
}
MultiChoicePageAlternative.defaultProps = {
  onSubmit: () => {},
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignSelf: 'center',
    alignContent: 'center',
    alignItems: 'center',
    backgroundColor: 'transparent',
  },
  prompt: {
    fontSize: 20,
    lineHeight: 24,
    maxWidth: 300,
    fontWeight: '500',
    letterSpacing: 0,
    color: '#14181B',
  },
  buttonStyle: {
    height: 50,
    width: 300,
    borderWidth: 2,
    borderColor: 'white',
    borderRadius: 100,
    paddingVertical: 10,
    paddingHorizontal: 30,
    margin: 5,
    shadowColor: '#ccc',
    shadowOffset: {
      height: 2,
      width: 2,
    },
    shadowOpacity: 0.4,
  },
  promptContainer: {
    maxWidth: 300,
    alignSelf: 'center',
    marginBottom: 40,
    // backgroundColor: 'transparent',
    // backgroundColor: 'white',
  },
  optionContainer: {
    // width: 300,
    alignSelf: 'center',
    padding: 20,
  },
  buttonWrapper: {
    borderRadius: 21,
    width: 300,
    height: 50,
    marginVertical: 40,
    alignSelf: 'center',
  },
});
